import {UserAddressType} from './UserAddressType';
import {ResidentRoleType} from './ResidentRoleType';
import {UserPhoneType} from './UserPhoneType';

export class Resident {
    constructor(
        public id: number = undefined,
        public suiteUserId: number = null,
        public email: string = '',
        public alternativeEmails: Array<any> = [],
        public photo: string = '',
        public isValidEmail: boolean = true,
        public fullName: string = '',
        public dateOfBirth: string = '',
        public occupancyDate: string = '',
        public moveOutDate: string = '',
        public addresses: Array<UserAddressType> = [],
        public phones: Array<UserPhoneType> = [],
        public groups: Array<any> = [],
        public emergencyContact: string = '',
        public emergencyContacts: Array<any> = [],
        public emergencyAssistantNotes: string = '',
        public note: string = '',
        public role: ResidentRoleType = 'unknown',
        public emailWaiverSigned: number = 0,
        public parcelWaiverSigned: 0 | 1 = 0,
        public keyWaiverSigned: number = 0,
        public maxTvUser: number = 0,
        public residentStatus: string = '',
        public isInvited: number = 0,
        public oauthId: number = null,
        public corporationNumber: string = '',
        public ownerInformationFormReceived: number = 0,
        public leaseReceived: number = 0,
        public tenantInformationFormReceived: number = 0,
        public primaryLeaseHolder: number = 0,
        public leaseStartDate: string = '',
        public disabilities: string = '',
        public consent: any = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public buildingAddress: string = '',
        public buildingTimezone: string = '',
        public cNSettings: any = null,
        public buzzFields: Array<any> = [],
        public keyCodeFields: Array<any> = [],
        public keyFobFields: Array<any> = [],
        public suiteBuzzFields: Array<any> = [],
        public suiteKeyCodeFields: Array<any> = [],
        public suiteKeyFobFields: Array<any> = [],
        public vehicles: Array<any> = [],
        public pets: Array<any> = [],
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            email: {editMode: false},
            fullName: {editMode: false},
            dateOfBirth: {editMode: false},
            addresses: {editMode: false},
            phones: {editMode: false},
            groups: {editMode: false},
            emergencyContact: {editMode: false},
            emergencyAssistantNotes: {editMode: false},
            role: {editMode: false},
            emailWaiverSigned: {editMode: false},
            parcelWaiverSigned: {editMode: false},
            keyWaiverSigned: {editMode: false},
            ownerInformationFormReceived: {editMode: false},
            leaseReceived: {editMode: false},
            tenantInformationFormReceived: {editMode: false},
            primaryLeaseHolder: {editMode: false},
        },
        public commonElementsFee: string = '',
    ) {
    }

    getEmailFilters() {
        return {
            buildingId: this.buildingId,
            buildingName: this.buildingName,
            checkedResidents: [this.suiteId],
            groups: [],
            guestChecked: this.role == 'guest' ? 1 : 0,
            guestCount: this.role == 'guest' ? 1 : 0,
            guestHalfChecked: this.role == 'guest' ? 1 : 0,
            notSetChecked: this.role == 'unknown' ? 1 : 0,
            notSetCount: this.role == 'unknown' ? 1 : 0,
            notSetHalfChecked: this.role == 'unknown' ? 1 : 0,
            occupantChecked: this.role == 'occupant' ? 1 : 0,
            occupantCount: this.role == 'occupant' ? 1 : 0,
            occupantHalfChecked: this.role == 'occupant' ? 1 : 0,
            offsiteResidentChecked: this.role == 'offsite_resident' ? 1 : 0,
            offsiteResidentCount: this.role == 'offsite_resident' ? 1 : 0,
            offsiteResidentHalfChecked: this.role == 'offsite_resident' ? 1 : 0,
            ownerFamilyChecked: this.role == 'owner_family' ? 1 : 0,
            ownerFamilyCount: this.role == 'owner_family' ? 1 : 0,
            ownerFamilyHalfChecked: this.role == 'owner_family' ? 1 : 0,
            ownerOffChecked: this.role == 'owner_off' ? 1 : 0,
            ownerOffCount: this.role == 'owner_off' ? 1 : 0,
            ownerOffHalfChecked: this.role == 'owner_off' ? 1 : 0,
            ownerOnChecked: this.role == 'owner_on' ? 1 : 0,
            ownerOnCount: this.role == 'owner_on' ? 1 : 0,
            ownerOnHalfChecked: this.role == 'owner_on' ? 1 : 0,
            residentChecked: this.role == 'resident' ? 1 : 0,
            residentCount: this.role == 'resident' ? 1 : 0,
            residentHalfChecked: this.role == 'resident' ? 1 : 0,
            residentOnlyNotOnDeedChecked: this.role == 'resident_only_not_on_deed' ? 1 : 0,
            residentOnlyNotOnDeedCount: this.role == 'resident_only_not_on_deed' ? 1 : 0,
            residentOnlyNotOnDeedHalfChecked: this.role == 'resident_only_not_on_deed' ? 1 : 0,
            residentOwnerChecked: this.role == 'resident_owner' ? 1 : 0,
            residentOwnerCount: this.role == 'resident_owner' ? 1 : 0,
            residentOwnerHalfChecked: this.role == 'resident_owner' ? 1 : 0,
            tenantsChecked: this.role == 'rent' ? 1 : 0,
            tenantsCount: this.role == 'rent' ? 1 : 0,
            tenantsHalfChecked: this.role == 'rent' ? 1 : 0
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Resident.ts